import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Underline = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 16 20' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M1 19H15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 1v7c0 3.87 3.13 7 7 7s7-3.13 7-7V1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M1 19H15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 1v7c0 3.87 3.13 7 7 7s7-3.13 7-7V1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    )}
  </IconBase>
);
